/* eslint-disable @next/next/no-html-link-for-pages */

'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import assetLoader from '@utils/internalImageLoader'
import { getFullFormattedDate } from '@components/Ackodrive/common/utils'
import Image from 'next/image'
import { TEAM_ACKODRIVE } from '@components/Ackodrive/common/constants'
import { cleanPathname } from '@components/Ackodrive/common/urlValidation'
import styles from './styles/recentArticles.module.scss'

const RecentArticles = ({ recentArticles }: any) => {
  const pathname = usePathname()

  return (
    <div className={styles.RecentArticleWrapper}>
      <div className={styles.RecentArticleHeader}>
        <span className={styles.HeaderText}>Recent</span>
        <span className={styles.HeaderText}>Articles</span>
      </div>
      <div className={styles.RecentArticleList}>
        {recentArticles?.map((item: any) => {
          const oneItem = item?.attributes
          const authorName = oneItem?.authorName?.data?.attributes?.name || TEAM_ACKODRIVE

          return (
            <div className={styles.RecentArticleItem} key={item?.data?.id}>
              <a href={cleanPathname(oneItem?.url)}>
                <p className={styles.RecentArticleTitle}>{oneItem?.title || oneItem?.articleTitle}</p>
              </a>
              <p className={styles.RecentArticleInfo}>
                {authorName} <span className={styles.Circle} /> {getFullFormattedDate(oneItem?.createdAt)}
              </p>
            </div>
          )
        })}
      </div>
      {pathname !== '/articles' && pathname !== '/articles/' ? (
        <a href="/articles/" key="all-articles">
          <div className={styles.AllArticlesLink}>
            <span>All Articles</span>
            <Image src={`${assetLoader()}/images/arrow-right.svg`} alt="icon" width="20" height="20" />
          </div>
        </a>
      ) : null}
    </div>
  )
}

export default RecentArticles
